module.exports = __webpack_public_path__ + "static/media/2122-service-1-1-min.0c235bd4.jpg";